import {Action, Choice} from "../../../feature/project/Shot";
import {Button, Flex, Input, Modal, Popover, Space, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImage, faPlus} from "@fortawesome/free-solid-svg-icons";
import LayerList from "../../common/LayerList";
import {ActionEditDialog} from "./ActionEditDialog";
import {AssetsBrowser} from "./AssetsBrowser";
import {Asset} from "../../../feature/project/fields";
import {useAppDispatch} from "../../../feature/tools";
import {useParams} from "react-router-dom";
import {deleteAction, saveAction} from "../../../feature/project/actionSlice";
const {confirm} = Modal;
export const ChoiceEditDialog = (
    props: {
        choice: Choice;
        onSave: (choice: Choice) => void;
        onCancel: () => void;
    }
) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const [choice, setChoice] = useState(props.choice)
    const [hasChanged, setHasChanged] = useState(false)
    const [title, setTitle] = useState(props.choice.title)
    const [actions, setActions] = useState(props.choice.actions)
    const [showEditActionDialog, setShowEditActionDialog] = useState<Action | undefined>(undefined)
    const [assetBrowser, setAssetBrowser] = useState(false)

    useEffect(() => {
        setChoice(props.choice)
        setTitle(props.choice.title)
        setActions(props.choice.actions)
        if (showEditActionDialog) {
            const action = {
                ...props.choice?.actions?.find((action: Action) => action.id === showEditActionDialog?.id),
            } as Action
            setShowEditActionDialog(action)
        }
    }, [props.choice]);

    useEffect(() => {
            setHasChanged(props.choice.title !== title || props.choice.actions !== actions)
        }, [props.choice, choice, title, actions]
    )

    const showConfirmArgumentDeletion = (item: Action) => {
        confirm({
            title: 'Delete Action',
            content: 'Are you sure you want to delete this action?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (projectId && item.id) {
                    dispatch(deleteAction({projectId: parseInt(projectId), actionId: item.id}))
                }
            },
        });
    }


    return (
        <Modal
            open={true}
            title={props.choice.id ? 'Edit Choice' : 'Add Choice'}
            width={1000}
            okText={'Save'}
            cancelText={'Close'}
            onCancel={props.onCancel}
            okButtonProps={
                {
                    disabled: !hasChanged
                }
            }
            onOk={() => props.onSave(
                {
                    ...props.choice,
                    title: title,
                    actions: actions
                })
            }
        >
            <Flex gap={16}>
                <Flex align={'center'} style={{
                    minWidth: 400,
                    height: 400,
                    borderRadius: 6,
                    clipPath: 'border-box',
                    position: "relative",
                    background: '#eeeeee'
                }}>
                    <div></div>
                </Flex>
                <Space direction={'vertical'} style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}}
                       size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Content</Typography>
                        <Flex gap={8}>
                            <Input style={{flexGrow: 1}} value={title} onChange={(e) => setTitle(e.target.value)} allowClear={true}/>
                            <Popover
                                onOpenChange={setAssetBrowser}
                                open={assetBrowser}
                                trigger={'click'}
                                placement={'rightTop'}
                                overlayInnerStyle={{marginTop: -10}}
                                arrow={false}
                                content={
                                    <AssetsBrowser
                                        categories={['Character', 'Object']}
                                        onAssetSelected={(asset: Asset | null) => {
                                            setTitle(asset ? asset.content : "")
                                            setAssetBrowser(false)
                                        }}
                                    />
                                }
                            >
                                <Button
                                    onClick={() => {
                                        setAssetBrowser(true)
                                    }}
                                >
                                    <FontAwesomeIcon icon={faImage}/>
                                </Button>
                            </Popover>
                        </Flex>
                    </div>
                    <div>
                    <Flex justify={'space-between'} className={'layer-group-title'} align={'center'}>
                        <Typography style={{fontWeight: 700}}>Actions</Typography>
                        <Button
                            icon={<FontAwesomeIcon icon={faPlus}/>}
                            type={'text'}
                            disabled={!choice.id}
                            onClick={() => {
                                setShowEditActionDialog({title:"", arguments:[]} as Action)
                            }}
                        />
                    </Flex>
                    {props.choice.actions ?
                        <LayerList
                            data={props.choice.actions}
                            itemStyle={{}}
                            title={(item, index) => item.title}
                            clickable={true}
                            onItemClick={(item) => {
                                setShowEditActionDialog(item)
                            }}
                            onDeleteClick={(item) => {
                                showConfirmArgumentDeletion(item)
                            }}
                            onEditClick={(item) => {
                                setShowEditActionDialog(item)
                            }}
                        />
                        : <Flex align={'center'} justify={'center'} style={{padding: 20}}>No actions added</Flex>
                    }
                    </div>
                </Space>
            </Flex>
            {showEditActionDialog ?
                <ActionEditDialog
                    action={showEditActionDialog}
                    onSave={(action: Action) => {
                        if (projectId && choice.id) {
                            dispatch(saveAction({
                                projectId: parseInt(projectId),
                                choiceId: choice.id,
                                action: action
                            }))
                            setShowEditActionDialog(undefined)
                        }
                    }}
                    onCancel={() => setShowEditActionDialog(undefined)}
                />
                : ''}
        </Modal>
    );
}